import React from 'react'
import { WHATSAPP_NUMBER } from '@constants/contact'
import Accordion from 'react-bootstrap/Accordion'
import AccordionHeaderContent from './AccordionHeaderContent'
import NotStartedStepMessage from './NotStartedStepMessage'
import { getStepState } from '../utils/getStepState'
import IOrder from '@interfaces/IOrder'

interface AccordionClinicRequestProps {
  stepProgress: number
  inProgressOrder: IOrder | null
}

const AccordionClinicRequest: React.FC<AccordionClinicRequestProps> = ({
  stepProgress,
  inProgressOrder
}) => {
  const stepState = getStepState(stepProgress)

  return (
    <Accordion.Item eventKey="7" className={`${stepState}-state desabled`}>
      <Accordion.Header>
        <AccordionHeaderContent
          stepState={stepState}
          progress={stepProgress}
          title="Aguardando Solicitação de Envio da Clínica"
        />
      </Accordion.Header>

      <Accordion.Body>
        <div className="check-sample p-3">
          {stepProgress < 7 ? (
            <NotStartedStepMessage />
          ) : (
            <>
              <p className="mb-0">Agora vamos coordenar a data de retirada da amostra de sêmen diretamente com a sua clínica!</p>
              <p className="mb-0">Assim que sua clínica definir a data de envio, nosso prazo de entrega é de até {inProgressOrder?.clinic?.delivery_time}hrs para qualquer localidade do Brasil!</p>
              <p className="mb-0 mt-3"><b>Importante:</b> a amostra de sêmen deve estar na sua clínica pelo menos 7 dias antes do início do tratamento!</p>
              <p className="mb-0 mt-3">
                Caso precise discutir o prazo de entrega da sua amostra de sêmen conosco, entre em contato através de nosso
                <a
                  target="_blank"
                  href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Preciso discutir o prazo de entrega da minha amostra de sêmen.')}`}
                  rel="noreferrer"
                >
                  <b> WhatsApp</b>
                </a>.
              </p>
            </>
          )}
        </div>
      </Accordion.Body>
    </Accordion.Item>
  )
}

export default AccordionClinicRequest
